function getAppUrl (appNodeEnv) {

    var currAppUrl;
    appNodeEnv === `production` || appNodeEnv === `staging`
        ? currAppUrl = import.meta.env.VITE_SITE_URL
        : currAppUrl = `http://localhost:5000`
    return currAppUrl;
};

function getReactAppUrl (appNodeEnv) {

    var currAppUrl;
    appNodeEnv === `production` || appNodeEnv === `staging`
        ? currAppUrl = import.meta.env.VITE_SITE_URL
        : currAppUrl = `http://localhost:3000`
    return currAppUrl;
};

function getLocationApiUrl (appNodeEnv) {

    var currApiUrl;
    appNodeEnv === `production` || appNodeEnv === `staging`
        ? currApiUrl = import.meta.env.VITE_API_ENDPOINT
        : currApiUrl = `http://localhost:7000`
    return currApiUrl;
};

export { getAppUrl, getLocationApiUrl, getReactAppUrl }